import { millicentsToDollars } from 'utils/money';

export const getSubtotal = (
  isCustomBudget: boolean,
  campaignBudgetMilliCent: number = 0,
): number =>
  isCustomBudget
    ? Number(campaignBudgetMilliCent)
    : millicentsToDollars(campaignBudgetMilliCent ?? 0);
